<script lang="ts">
import { defineComponent } from 'vue';

import { makeDisabledProps, makeTagProps, makeTextProps, useDisabled } from '../../composable';

export const componentName = 'CdsInputLabel';
export default defineComponent({
  name: componentName,
  props: {
    ...makeTextProps(),
    ...makeDisabledProps(),
    ...makeTagProps({
      tag: 'label'
    })
  },
  setup(props) {
    const { disabledClasses } = useDisabled(props);

    return {
      disabledClasses
    };
  }
});
</script>

<template>
  <component :is="tag" class="cds-input__label" :class="disabledClasses">
    <span class="cds-input__label-text">
      {{ text }}
      <slot />
    </span>
  </component>
</template>
